// The comment box's colours (ENG-1119).
//
// They live here, under src/components/nodes/, because that directory is the
// palette lock's FUNCTIONAL allowlist (ENG-880): node colour is category coding
// in the Unreal convention and must not follow the user's theme. The editors
// import from here rather than writing literals, because BlueprintEditor.jsx
// and EventGraph.jsx are locked to an exact hex count that only ever shrinks —
// the same reason cameraTheme's CAMERA_ACCENT exists.
//
// A comment carries ONE hex (Unreal's CommentColor) and every surface tint is
// derived from it, so a colour change cannot half-apply.
//
// THE ALPHAS ARE THE POINT. The first version filled at 10% and outlined at
// 50%, which was invisible on the light graph canvas — "the colors are not
// visible" (Andres, with a comment on screen). A comment has to read as a
// region at a glance, without competing with the nodes inside it, so the fill
// is low but the BORDER and HEADER are solid.

export const COMMENT_ACCENT = '#c8a940'

/**
 * The colours a comment can take. Unreal's comment node carries a `CommentColor`
 * (EditAnywhere, EdGraphNode_Comment.h), so colour-coding regions of a graph is
 * expected behaviour rather than an invention; offered as swatches because a
 * full picker is a lot of UI for a decoration.
 *
 * Chosen to read on BOTH the light and dark graph canvases.
 */
export const COMMENT_COLORS = Object.freeze([
  COMMENT_ACCENT, // amber (default)
  '#4a90d9',      // blue
  '#5bb85b',      // green
  '#c0504d',      // red
  '#8c6bd8',      // violet
  '#7a8288',      // slate
])
export const DEFAULT_COMMENT_COLOR = COMMENT_ACCENT

/** Expand a comment's hex into the surfaces the node draws. */
export function commentPalette(hex, selected = false) {
  const base = typeof hex === 'string' && /^#[0-9a-f]{6}$/i.test(hex) ? hex : COMMENT_ACCENT
  return {
    accent: base,
    // Solid border: the one mark that has to survive any background.
    border: selected ? base : `${base}b0`,
    // Header reads as a label bar, not a wash.
    header: `${base}38`,
    headerLine: `${base}70`,
    // Fill stays light so the nodes inside keep their contrast; a touch more
    // when selected so the selection is legible without moving the border.
    fill: selected ? `${base}26` : `${base}1a`,
    // Text is the colour at full strength — on both canvases it is the most
    // readable option that still ties the note to its box.
    text: base,
  }
}
